var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect, _ellipse, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFalconBb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 120,
    viewBox: "0 -2 20 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 5H1V50H19V5Z",
    fill: "#868CA6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 5H2V50H18V5Z",
    fill: "#AFB3C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 50H19L11.6005 59.2494C11.2209 59.7238 10.6463 60 10.0388 60H9.96125C9.35368 60 8.77906 59.7238 8.39951 59.2494L1 50Z",
    fill: "#868CA6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 50H18L11.44 58.3025C11.0919 58.743 10.5614 59 10 59C9.4386 59 8.90808 58.743 8.56004 58.3025L2 50Z",
    fill: "#AFB3C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.5C10.7239 12.5 10.5 12.7239 10.5 13C10.5 13.2761 10.7239 13.5 11 13.5V12.5ZM11 13.5H19V12.5H11V13.5Z",
    fill: "#0063C3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 17.5C10.7239 17.5 10.5 17.7239 10.5 18C10.5 18.2761 10.7239 18.5 11 18.5V17.5ZM11 18.5H19V17.5H11V18.5Z",
    fill: "#0063C3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 22.5C10.7239 22.5 10.5 22.7239 10.5 23C10.5 23.2761 10.7239 23.5 11 23.5V22.5ZM11 23.5H19V22.5H11V23.5Z",
    fill: "#0063C3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 25.6826H3L3.00008 49.7497L8.74011 57.0144C9.04465 57.3998 9.50886 57.6247 10.0001 57.6247C10.4913 57.6247 10.9555 57.3998 11.2601 57.0144L16.9998 49.75L17 25.6826Z",
    fill: "#3FB0E0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27.5C10.7239 27.5 10.5 27.7239 10.5 28C10.5 28.2761 10.7239 28.5 11 28.5V27.5ZM11 28.5H19V27.5H11V28.5Z",
    fill: "#0063C3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M11 32.5C10.7239 32.5 10.5 32.7239 10.5 33C10.5 33.2761 10.7239 33.5 11 33.5V32.5ZM11 33.5H19V32.5H11V33.5Z",
    fill: "#0063C3"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 8.26416,
    width: 17.9961,
    height: 16.0877,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.99793,
    cy: 16.3082,
    rx: 4.99891,
    ry: 5.02742,
    fill: "#FAC848"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11 37.5C10.7239 37.5 10.5 37.7239 10.5 38C10.5 38.2761 10.7239 38.5 11 38.5V37.5ZM11 38.5H19V37.5H11V38.5Z",
    fill: "#0063C3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11 42.5C10.7239 42.5 10.5 42.7239 10.5 43C10.5 43.2761 10.7239 43.5 11 43.5V42.5ZM11 43.5H19V42.5H11V43.5Z",
    fill: "#0063C3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5H0V6H20V5Z",
    fill: "#797E95"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M20 5.27474V6.27139C20 6.42397 19.8806 6.55014 19.7311 6.55992C19.7243 6.5609 19.7185 6.5609 19.7117 6.5609H0.287337C0.280542 6.5609 0.274717 6.5609 0.267922 6.55992C0.118429 6.55014 0 6.42397 0 6.27139V5.27474C0 5.11531 0.129107 4.98523 0.287337 4.98523H0.365966V0.665088C0.365966 0.532071 0.461098 0.420571 0.586322 0.397097V0.272882C0.586322 0.123237 0.708635 0 0.858128 0H19.1419C19.2118 0 19.2758 0.027386 19.3244 0.0713992C19.3321 0.0782457 19.3389 0.0850922 19.3457 0.0929167C19.3477 0.0948729 19.3496 0.096829 19.3516 0.0997632C19.3904 0.146711 19.4137 0.207351 19.4137 0.272882V0.397097C19.5379 0.421549 19.634 0.533049 19.634 0.665088V4.98523H19.7127C19.8709 4.98425 20 5.11433 20 5.27474Z",
    fill: "#0063C3"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50279 6.27041V5.27474C7.50279 5.11531 7.6319 4.98523 7.79013 4.98523H7.86876V0.665088C7.86876 0.532071 7.96389 0.420571 8.08911 0.397097V0.272882C8.08911 0.123237 8.21143 0 8.36092 0H0.858128C0.708635 0 0.586322 0.122259 0.586322 0.272882V0.397097C0.462069 0.421549 0.365966 0.533049 0.365966 0.665088V4.98523H0.287337C0.129107 4.98523 0 5.11531 0 5.27474V6.27139C0 6.42397 0.118429 6.55014 0.267922 6.55992C0.274717 6.5609 0.280542 6.5609 0.287337 6.5609H7.79013C7.78333 6.5609 7.77751 6.5609 7.77071 6.55992C7.62122 6.54916 7.50279 6.42299 7.50279 6.27041Z",
    fill: "#2585E1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.52943 0.50293H1.06445V4.97076H1.52943V0.50293Z",
    fill: "#409DF6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M2.49623 0.50293H2.03125V4.97075H2.49623V0.50293Z",
    fill: "#409DF6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M3.464 0.50293H2.99805V4.97075H3.464V0.50293Z",
    fill: "#409DF6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M4.42982 0.50293H3.96484V4.97075H4.42982V0.50293Z",
    fill: "#409DF6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M5.39662 0.50293H4.93164V4.97075H5.39662V0.50293Z",
    fill: "#409DF6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.36439 0.50293H5.89844V4.97075H6.36439V0.50293Z",
    fill: "#409DF6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33021 0.50293H6.86523V4.97075H7.33021V0.50293Z",
    fill: "#409DF6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29701 0.50293H7.83203V4.97075H8.29701V0.50293Z",
    fill: "#409DF6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M9.26381 0.50293H8.79883V4.97075H9.26381V0.50293Z",
    fill: "#1782E9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2306 0.50293H9.76562V4.97075H10.2306V0.50293Z",
    fill: "#1782E9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1984 0.50293H10.7334V4.97075H11.1984V0.50293Z",
    fill: "#1782E9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1671 0.50293H11.7012V4.97075H12.1671V0.50293Z",
    fill: "#1782E9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1329 0.50293H12.668V4.97075H13.1329V0.50293Z",
    fill: "#1782E9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1007 0.50293H13.6348V4.97075H14.1007V0.50293Z",
    fill: "#1782E9"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0675 0.50293H14.6016V4.97075H15.0675V0.50293Z",
    fill: "#1782E9"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0343 0.50293H15.5684V4.97075H16.0343V0.50293Z",
    fill: "#1782E9"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0011 0.50293H16.5352V4.97075H17.0011V0.50293Z",
    fill: "#1782E9"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9669 0.50293H17.502V4.97075H17.9669V0.50293Z",
    fill: "#1782E9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9337 0.50293H18.4688V4.97075H18.9337V0.50293Z",
    fill: "#1782E9"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.0271 57.5682L13.9544 48.9091V5H18.9725V50L11.573 59.2494C11.1935 59.7238 10.6189 60 10.0113 60H9.9338C9.32623 60 8.75161 59.7238 8.37206 59.2494L7.0271 57.5682Z",
    fill: "black",
    fillOpacity: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFalconBb);
export default __webpack_public_path__ + "static/media/falcon-bb.550bc4fc82ae961724e97e9f64141fb7.svg";
export { ForwardRef as ReactComponent };